import React from 'react';
//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/sales.module.scss';
//bottomsheet
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//hook
import useSalesHook from 'src/webapp/hooks/sales/sales.hook';
//comp
import ReservInfoProfile from './ReservInfo.Profile';

export default function _bsReservInfo(props) {
	const { isOpen, data } = props;//props
	const { reservMemberProfileAPI, profile } = useSalesHook();


    return (
        <BottomSheet open={isOpen} onDismiss={(e) => { props.onDismiss(false) }}
			className={'bottomsheetContainer'}	
			onSpringStart={async (event) => {
				if(event.type === 'OPEN') { reservMemberProfileAPI(data); }
			}}
			header={
				<>
				<button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false, null)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'3.75rem'}} className={'bottomsheetHeaderContainer'}>
					<h1>상세보기</h1>
                </div>
				</>
            }
            footer={
				<div style={{marginTop:'3.75rem'}} className={styles.bottomsheetReservInfoBtnArea}>
					<button onClick={(e) => props.onDismiss(false)}>확인</button>
                </div>
            }
			snapPoints={({ maxHeight }) => maxHeight}
            skipInitialTransition={false} scrollLocking={false} expandOnContentDrag={true}>
			<ReservInfoProfile data={profile} />
		</BottomSheet>
	);
  }